


















































import { defineComponent, ref, PropType, computed } from "@vue/composition-api";
import { nl2br } from "~/helpers";
import { Product } from "~/modules/catalog/product/types";

export default defineComponent({
  name: "ProductDescription",
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
  },
  setup(props) {
    const description_click = ref(true);
    const instruction_click = ref(false);
    const material_click = ref(false);

    const productShortDescription = computed(
      () =>
        props.product?.short_description_map || props.product?.description_map
    );

    const productMaterials = computed(() => props.product?.materials || "");
    const productInstruction = computed(() => props.product?.instruction || "");

    return {
      description_click,
      instruction_click,
      material_click,
      nl2br,
      productShortDescription,
      productMaterials,
      productInstruction,
    };
  },
});
